import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

const SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  'https://2abba42b7a88f6468c99a5835a78d939@o4511119624437760.ingest.us.sentry.io/4511121902141440';

/**
 * Call once before React renders. Prefer REACT_APP_SENTRY_DSN in `.env` per environment.
 */
export function initSentry(): void {
  if (!SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    attachStacktrace: true,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0
  });
}

initSentry();
